import { GATEWAY_BASE } from '@/constants/baseUrls';

export const PROSPECT_BASE_URL: Record<string, string> = {
  local: `${GATEWAY_BASE.dev}/devmaj-quote-prospect`,
  devmaj: `${GATEWAY_BASE.dev}/devmaj-quote-prospect`,
  majstg: `${GATEWAY_BASE.stageOrProd}/majstg-quote-prospect`,
  prd: `${GATEWAY_BASE.stageOrProd}/quote-prospect`,
};

export const FEATURE_FLAGS_BASE_URL: Record<string, string> = {
  local: `${GATEWAY_BASE.dev}/devmaj-quote-feature-flags/quote-feature-flags`,
  devmaj: `${GATEWAY_BASE.dev}/devmaj-quote-feature-flags/quote-feature-flags`,
  majstg: `${GATEWAY_BASE.stageOrProd}/majstg-quote-feature-flags/quote-feature-flags`,
  prd: `${GATEWAY_BASE.stageOrProd}/quote-feature-flags/quote-feature-flags`,
};

export const PRODUCT_SERVICE_URL: Record<string, string> = {
  local: `${GATEWAY_BASE.dev}/devmaj-product`,
  devmaj: `${GATEWAY_BASE.dev}/devmaj-product`,
  majstg: `${GATEWAY_BASE.stageOrProd}/majstg-product`,
  prd: `${GATEWAY_BASE.stageOrProd}/product`,
};

export const JWT_BASE_URL: Record<string, string> = {
  local: `${GATEWAY_BASE.dev}/devmaj-ecomm-infra`,
  devmaj: `${GATEWAY_BASE.dev}/devmaj-ecomm-infra`,
  majstg: `${GATEWAY_BASE.stageOrProd}/majstg-ecomm-infra`,
  prd: `${GATEWAY_BASE.stageOrProd}/ecomm-infra`,
};

export const SALESFORCE_URL: Record<string, string> = {
  local: 'https://sunrun--devmaj.sandbox.my.salesforce.com',
  devmaj: 'https://sunrun--devmaj.sandbox.my.salesforce.com',
  majstg: 'https://sunrun--majstg.sandbox.my.salesforce.com',
  prd: 'https://sunrun.my.salesforce.com',
};
